var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.level && _vm.level > 0)?_c('div',{staticClass:"ui-label-author-rank"},[_c('div',{staticClass:"rank-left"}),_c('div',{staticClass:"rank-center"},_vm._l((_vm.levelArr),function(num,index){return _c('div',{key:index,staticClass:"rank-number",class:("level-num-" + num)})})),_c('div',{staticClass:"rank-right"})]):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62faf5e8","hasScoped":false,"optionsId":"0","buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../src/ui/label/author-rank.vue
// module id = 549
// module chunks = 0 1 2 3